export const getAdStudioSummaryBarStyle = () => ({
  '@keyframes inProgressSpin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },

  adStudioSummaryBar: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    '& .breadcrumb-wrapper': {
      width: '100%',
      paddingLeft: '6px',
    },
  },

  summaryBar: {
    '& .back-button:focus': {
      border: '1px solid black',
    },
  },

  inProgressContent: {
    position: 'absolute',
    right: 40,
    top: 0,
    '& .in-progress-button': {
      '& i': {
        animationName: '$inProgressSpin',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
      },
    },
  },
});
